/**
 * @generated SignedSource<<061f5b4198f830fb7d3e1f92ac3c82f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RewardKind = "CrmTreeHeadUpdater" | "ExternalLicense" | "GamificationPoints" | "IHKCertificate" | "IHKCertificateBundle" | "LearnStreak";
import { FragmentRefs } from "relay-runtime";
export type createIhkCertificateRewardBundleButton_TreeNodeFragment$data = {
  readonly id: string;
  readonly typeDefinition: {
    readonly rewards?: ReadonlyArray<{
      readonly id: string;
      readonly kind: RewardKind;
    }>;
  };
  readonly " $fragmentType": "createIhkCertificateRewardBundleButton_TreeNodeFragment";
};
export type createIhkCertificateRewardBundleButton_TreeNodeFragment$key = {
  readonly " $data"?: createIhkCertificateRewardBundleButton_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"createIhkCertificateRewardBundleButton_TreeNodeFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "createIhkCertificateRewardBundleButton_TreeNodeFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "typeDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "rewards",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ELearningContentTypeDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};
})();

(node as any).hash = "2bfa2bec2beed3bbf621d92ac770bd0a";

export default node;
